"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "*home"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.59038 0.807424C7.83112 0.620182 8.16823 0.620182 8.40897 0.807424L14.409 5.47409C14.5714 5.6004 14.6663 5.7946 14.6663 6.00033V13.3337C14.6663 13.8641 14.4556 14.3728 14.0806 14.7479C13.7055 15.1229 13.1968 15.3337 12.6663 15.3337H3.33301C2.80257 15.3337 2.29387 15.1229 1.91879 14.7479C1.54372 14.3728 1.33301 13.8641 1.33301 13.3337V6.00033C1.33301 5.7946 1.42799 5.6004 1.59038 5.47409L7.59038 0.807424ZM2.66634 6.32638V13.3337C2.66634 13.5105 2.73658 13.68 2.8616 13.8051C2.98663 13.9301 3.1562 14.0003 3.33301 14.0003H12.6663C12.8432 14.0003 13.0127 13.9301 13.1377 13.8051C13.2628 13.68 13.333 13.5105 13.333 13.3337V6.32638L7.99967 2.17823L2.66634 6.32638Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_2",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.33301 7.99967C5.33301 7.63148 5.63148 7.33301 5.99967 7.33301H9.99967C10.3679 7.33301 10.6663 7.63148 10.6663 7.99967V14.6663C10.6663 15.0345 10.3679 15.333 9.99967 15.333C9.63148 15.333 9.33301 15.0345 9.33301 14.6663V8.66634H6.66634V14.6663C6.66634 15.0345 6.36786 15.333 5.99967 15.333C5.63148 15.333 5.33301 15.0345 5.33301 14.6663V7.99967Z",
    fill: fill
  })));
};

exports["default"] = _default;